// extracted by mini-css-extract-plugin
module.exports = {"root":"dd31006766--root--FVT6Q"};